import { Direction } from './direction';


export class UserProfile {

    id: number|undefined;
    creationDate: Date;
    description: string;
    name: string;
    updateDate: Date;
    type: string;
    direction: Direction;
  }